import { render } from "./ManageOrgUnit.vue?vue&type=template&id=f603111e"
import script from "./ManageOrgUnit.vue?vue&type=script&lang=js"
export * from "./ManageOrgUnit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__